import { render, staticRenderFns } from "./CKMingxi.vue?vue&type=template&id=1284963e&scoped=true&"
import script from "./CKMingxi.vue?vue&type=script&lang=js&"
export * from "./CKMingxi.vue?vue&type=script&lang=js&"
import style0 from "./CKMingxi.vue?vue&type=style&index=0&id=1284963e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1284963e",
  null
  
)

export default component.exports